import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useField } from "react-final-form";
import { FileInputWithCrop } from "@vk-hr-tek/ui/input";
import { composeValidators } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function FileInputWithCrop_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else FileInputWithCrop_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const FileInputWithCrop_FileInputWithCrop = (t0)=>{
    const $ = c(37);
    const { label, labelIcon, tooltip, name, variant: t1, placeholder, required: t2, disabled: t3, onChange, loading: t4, loadingText: t5, showErrorWithoutTouched: t6, validate, cache, fullWidth, bannerText, autorecognitionQr: t7, helperText, testId, withAuth, allowedTypes, aspectRatioOptions, dialogTitle, dialogDescription, sizeAspect } = t0;
    const variant = void 0 === t1 ? "input" : t1;
    const required = void 0 === t2 ? false : t2;
    const disabled = void 0 === t3 ? false : t3;
    const loading = void 0 === t4 ? false : t4;
    const loadingText = void 0 === t5 ? void 0 : t5;
    const showErrorWithoutTouched = void 0 === t6 ? false : t6;
    const autorecognitionQr = void 0 === t7 ? false : t7;
    let t8;
    if ($[0] !== validate) {
        t8 = validate || [];
        $[0] = validate;
        $[1] = t8;
    } else t8 = $[1];
    let t9;
    if ($[2] !== t8) {
        t9 = composeValidators(t8);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    const validators = t9;
    let t10;
    if ($[4] !== validators) {
        t10 = {
            validate: validators
        };
        $[4] = validators;
        $[5] = t10;
    } else t10 = $[5];
    const { input, meta } = useField(name, t10);
    const { onChange: onChangeInput, onBlur } = input;
    const error = showErrorWithoutTouched ? !!input.value && meta.error : meta.touched && meta.error;
    let t11;
    if ($[6] !== onChange || $[7] !== onChangeInput) {
        t11 = (props)=>{
            onChangeInput(props);
            null == onChange || onChange(props);
        };
        $[6] = onChange;
        $[7] = onChangeInput;
        $[8] = t11;
    } else t11 = $[8];
    let t12;
    if ($[9] !== allowedTypes || $[10] !== aspectRatioOptions || $[11] !== autorecognitionQr || $[12] !== bannerText || $[13] !== cache || $[14] !== dialogDescription || $[15] !== dialogTitle || $[16] !== disabled || $[17] !== error || $[18] !== fullWidth || $[19] !== helperText || $[20] !== input || $[21] !== label || $[22] !== labelIcon || $[23] !== loading || $[24] !== loadingText || $[25] !== meta.error || $[26] !== onBlur || $[27] !== placeholder || $[28] !== required || $[29] !== sizeAspect || $[30] !== t11 || $[31] !== testId || $[32] !== tooltip || $[33] !== validators || $[34] !== variant || $[35] !== withAuth) {
        t12 = /*#__PURE__*/ jsx(FileInputWithCrop, _object_spread_props(_object_spread({}, input), {
            label: label,
            labelIcon: labelIcon,
            value: input.value,
            onChange: t11,
            variant: variant,
            tooltip: tooltip,
            required: required,
            error: error,
            errorText: meta.error,
            helperText: helperText,
            disabled: disabled,
            loading: loading,
            loadingText: loadingText,
            onBlur: onBlur,
            cache: cache,
            fullWidth: fullWidth,
            placeholder: placeholder,
            autorecognitionQr: autorecognitionQr,
            bannerText: bannerText,
            testId: testId,
            withAuth: withAuth,
            validators: validators,
            allowedTypes: allowedTypes,
            aspectRatioOptions: aspectRatioOptions,
            dialogTitle: dialogTitle,
            dialogDescription: dialogDescription,
            sizeAspect: sizeAspect
        }));
        $[9] = allowedTypes;
        $[10] = aspectRatioOptions;
        $[11] = autorecognitionQr;
        $[12] = bannerText;
        $[13] = cache;
        $[14] = dialogDescription;
        $[15] = dialogTitle;
        $[16] = disabled;
        $[17] = error;
        $[18] = fullWidth;
        $[19] = helperText;
        $[20] = input;
        $[21] = label;
        $[22] = labelIcon;
        $[23] = loading;
        $[24] = loadingText;
        $[25] = meta.error;
        $[26] = onBlur;
        $[27] = placeholder;
        $[28] = required;
        $[29] = sizeAspect;
        $[30] = t11;
        $[31] = testId;
        $[32] = tooltip;
        $[33] = validators;
        $[34] = variant;
        $[35] = withAuth;
        $[36] = t12;
    } else t12 = $[36];
    return t12;
};
export { FileInputWithCrop_FileInputWithCrop as FileInputWithCrop };
